import { X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { safeLocalGet, safeLocalSet } from '../lib/browserStorage'

const STORAGE_KEY = 'closedrecord:advertisingRevenuePopupLastShownAt'
const COOLDOWN_MS = 48 * 60 * 60 * 1000

export function AdvertisingRevenuePopup() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const now = Date.now()
    let showTimer: number | undefined

    try {
      const lastShownAt = Number(safeLocalGet(STORAGE_KEY))
      const canShow = !Number.isFinite(lastShownAt) || now - lastShownAt >= COOLDOWN_MS

      if (canShow) {
        safeLocalSet(STORAGE_KEY, String(now))
        showTimer = window.setTimeout(() => setVisible(true), 0)
      }
    } catch {
      showTimer = window.setTimeout(() => setVisible(true), 0)
    }

    return () => {
      if (showTimer) window.clearTimeout(showTimer)
    }
  }, [])

  if (!visible) return null

  return (
    <aside
      aria-live="polite"
      className="fixed bottom-5 right-5 z-[70] w-[min(calc(100vw-2.5rem),360px)] border border-crusta-500/70 bg-[#080A0F]/95 p-5 text-white shadow-[0_0_28px_rgba(255,45,120,0.28),-10px_10px_0_rgba(0,245,255,0.14)] backdrop-blur-xl"
    >
      <div className="pointer-events-none absolute left-0 top-0 h-1 w-full bg-crusta-500" />
      <button
        type="button"
        aria-label="Close advertising revenue message"
        onClick={() => setVisible(false)}
        className="absolute right-3 top-3 border border-white/20 bg-white/5 p-1 text-white/70 transition hover:border-crusta-800/70 hover:text-white"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
      <p className="font-interactive pr-8 text-xl font-bold uppercase leading-tight tracking-[0.04em] text-white drop-shadow-[0_0_14px_rgba(255,45,120,0.35)]">
        35% of Advertising Revenue donated to charity
      </p>
    </aside>
  )
}
